import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import { useReward } from 'react-rewards';

Modal.setAppElement('#root');

const ModalJackpot = ({ modalStatus, closeModal, gifts }) => {
	const { reward: confettiReward, isAnimating: isConfettiAnimating } =
		useReward('confettiReward', 'confetti', {
			elementCount: 500,
			zIndex: -2,
			elementSize: 12,
			spread: 360,
		});

	useEffect(() => {
		setTimeout(() => {
			document.querySelector('.confetti').click();
		}, 500);
	}, []);

	const afterOpenModal = () => {};

	const selfClose = (event) => {
		event.preventDefault();
		closeModal();
	};

	return (
		<Modal
			isOpen={modalStatus}
			onAfterOpen={afterOpenModal}
			onRequestClose={selfClose}
			contentLabel="Example Modal"
			portalClassName="ReactModalPortal"
			overlayClassName=""
			className="animated fadeInDown faster modal-jackpot"
		>
			<h2>
				<img src="/images/title-congrat3.png" alt="" className="title-modal" />
			</h2>
			<div className="modal-description">
				<p>Bạn đã nhận được</p>
				<p className="name"> {gifts[0]?.reward_name}</p>
				<img src={gifts[0]?.image} alt="" />
				<button
					disabled={isConfettiAnimating}
					onClick={() => {
						confettiReward();
					}}
					className="confetti"
				>
					<span id="confettiReward" />
				</button>
			</div>
		</Modal>
	);
};

export default ModalJackpot;
